module.exports = __webpack_public_path__ + "static/img/login.bee1ae5b.png";